<template>
  <div>
    <v-card-text>
      <image-uploader
          :debug="0"
          :maxWidth="512"
          :quality="1"
          :autoRotate=false
          outputFormat="blob"
          :preview=false
          :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
          :capture="false"
          accept="video/*,image/*"
          doNotResize="['gif', 'svg']"
          @input="setImage"
          ref="imageUploader"
      ></image-uploader>
      <div v-if="progress">
        <div v-if="uploadStatus !== ''">{{uploadStatus}} {{progress}} %</div>
      </div>
    </v-card-text>
    <v-card-actions v-if="image">
      <v-spacer></v-spacer>
      <v-btn @click="removeImage" text outlined class="error--text"><v-icon>delete</v-icon>delete</v-btn>
    </v-card-actions>
  </div>
</template>
<script>
import { v1 as uuidv1 } from 'uuid';
import { ref, getStorage, deleteObject, uploadBytesResumable, getDownloadURL } from "firebase/storage";
export default {
  props: ['id', 'path'],
  data () {
    return {
      imageUrl: '',
      image: null,
      progress: undefined,
      uploadStatus: '',
      imageId: ''
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    }
  },
  methods: {
    hasImage (data) {
        console.log(data)
    },
    setImage (img) {
      this.image = img
      this.uploadImage()
    },
    removeImage () {
      let userId = this.user.uid
      let storage = getStorage()
      let imgRef = ref(storage, '/users/' + userId + '/' + this.path + '/' + this.imageId)
      this.uploadStatus = ''
      deleteObject(imgRef)
          .then(() => {
            return this.$emit('removeImage', true)
          })
          .then(() => {
            this.image = null
            this.initiate ()
          })
          .catch((err) => {
            this.$store.dispatch('setError', err)
          });

    },
    uploadImage () {
      let file = this.image
      let imageId = uuidv1()
      this.imageId = imageId
      let userId = this.user.uid
      let storage = this.$store.state.storage
      let imgRef = ref(storage,'/users/' + userId + '/' + this.path + '/' + imageId)
      const uploadTask = uploadBytesResumable(imgRef, file)
      return uploadTask.on('state_changed',
          (snapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.progress = progress
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
              case 'paused':
                this.uploadStatus = "Uploading paused"
                // console.log('Upload is paused');
                break;
              case 'running':
                this.uploadStatus = "Image Uploading"
                // console.log('Upload is running');
                break;
            }
          },
          (err) => {
            this.$store.dispatch('setError', err)
          },
          () => {
            this.initiate()
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              //console.log('File available at', downloadURL);
              return this.$emit('imageLinkFound', {url: downloadURL, id: imageId, path: this.path})
            });
          }
      );
    },
    initiate() {
      // console.log(this.$refs.imageUploader.$el.children[1])
      this.$refs.imageUploader.$el.children[1].value = ""
      this.uploadStatus = ''
    }

  }
}
</script>
